import React, { useEffect, useState } from 'react';
import { Cookies } from '../index.js';
import axios from 'axios';
import { Outlet, useNavigate, useLocation, Routes, Route, Link } from "react-router-dom";
import { alert_error, alert_success } from '../AppContext';
import { update_stable_coins } from '../order/orders/actions.js';
import { useSelector, useDispatch } from 'react-redux';
import { isLocalHost } from '../shared/host_utils.js';

function Hienxu() {
    const [currency, setCurrency] = useState(Cookies.get('currency'));     // khởi tạo default là VND
    const handleSelect = (e) => {
        Cookies.set('currency', e.target.value);
        setCurrency(e.target.value);
        users_get_balance();
    };
    const EXCHANGE_RATES = {
        USD: 28012,  // ví dụ: 1 USD = 23.400 VND
        EUR: 30000,  // ví dụ: 1 EUR = 26.000 VND
        VND: 1
    }
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [linknap, setlinknap] = useState(false);
    const stable_coins = useSelector(state => state.stable_coins);
    const set_stable_coins = (value) => {
        if (value == '0') {
            dispatch(update_stable_coins('1'));
        } else {
            dispatch(update_stable_coins(value));
        }
    };
    const set_coins = (value) => {
        const currency_ok = Cookies.get('currency');
        const rate = EXCHANGE_RATES[currency_ok] || 1;
        const converted = value / rate;

        // Làm tròn 2 chữ số, vẫn giữ kiểu số
        const rounded = parseFloat(converted.toFixed(4));

        set_stable_coins(rounded);
    };

    function users_get_balance() {
        const myCookieValueok = Cookies.get('apikey');
        if (myCookieValueok) {
            setlinknap('/shop/wallet/donate?apikey=' + myCookieValueok);
            axios.get('https://nginx.hust.media/go/profile/setting/get_status?apikey=' + myCookieValueok + '&mode=overview')
                .then(response => {
                    set_coins(response.data.money);
                    Cookies.set('username', response.data.username);
                })

        };
    }
    function users_get_status() {
        const myCookieValueok = Cookies.get('apikey');
        if (myCookieValueok) {
            setlinknap('/shop/wallet/donate?apikey=' + myCookieValueok);
            axios.get('https://kotlin.tecom.pro/profiles/get_status?apikey=' + myCookieValueok)
                .then(response => {
                    users_status_process(response.data);
                })

        };
    } function users_status_process(info) {
        const users_status = info.users_status;
        const status_detail = info.status_detail;
        if (users_status && status_detail) {
            Cookies.set('users_status', users_status);
        }
        else {
        }
    };
    function switch_router(link) {
        if (window.location.hostname == 'hust.media') {
            const myCookieValue = Cookies.get('apikey');
            window.location.href = "https://tecom.pro" + link + "&apikey=" + myCookieValue;
        }
        else {
            navigate(link);
        }
    };
    useEffect(() => {
        if (!currency) {
            setCurrency("VND");
        }
        if (!Cookies.get('currency')) {
            Cookies.set('currency', "VND");
        }
        users_get_cron();
        setInterval(users_get_cron, 10000);
    }, []);

    function users_get_cron(link) {
        const random = Math.round(Math.random() * 2);

        if (random == 2) {
            users_get_status();
            users_get_balance();
        } else {
            users_get_balance();
        }
    };
    return (
        <>
            {
                stable_coins !== null && stable_coins !== undefined && stable_coins !== '' && (<>
                    {( (window.location.href.includes('hust.media') || isLocalHost(window.location.hostname)) || window.location.href.includes('tecom.pro')) && (<>
                        <div className="inline-flex h-7 max-w-full items-center rounded-full bg-blue-500 shadow-sm ring-1 ring-blue-300/70">
                            <button
                                type="button"
                                onClick={() => switch_router(linknap)}
                                className="relative z-10 inline-flex h-7 min-w-0 items-center justify-center pl-1.5 pr-2.5 text-center text-xs font-semibold text-white transition hover:bg-blue-600"
                                title="Mở ví coin"
                            >
                                <span
                                    className="flex items-center truncate leading-none text-pink-100"
                                    id="my_vnd"
                                    style={{ fontSize: '12px', lineHeight: 1, fontWeight: 600 }}
                                >
                                    {stable_coins}
                                </span>
                                <img
                                    src="https://hust.media/img/icon/coin.webp"
                                    alt="Coin"
                                    className="absolute right-[-14px] top-[calc(50%+2.5px)] z-20 h-6 w-6 -translate-y-1/2 object-contain"
                                />
                            </button>
                            <select
                                value={currency}
                                onChange={handleSelect}
                                aria-label="Chọn đơn vị tiền tệ"
                                className="relative z-0 h-7 w-auto min-w-0 shrink-0 cursor-pointer appearance-none rounded-r-full border-2 border-blue-500 bg-pink-100 pl-2 pr-1 text-right text-blue-500 outline-none"
                                style={{ fontSize: '11px', lineHeight: 1, fontWeight: 600, color: '#3b82f6', backgroundColor: '#fce7f3' }}
                            >
                                <option value="VND">VND</option>
                                <option value="USD">USD</option>
                                <option value="EUR">EUR</option>
                            </select>
                        </div>
                    </>)}
                </>)
            }
        </>
    )
}
export default Hienxu;
